import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import InputEmail from "../../common/Input/InputEmail";
import InputNumber from "../../common/Input/InputPhNumber";
import InputName from "../../common/Input/InputName";
import Image from "../../common/lazyLoadImage/image";
import InputText from "../../common/Input/InputText";
import InputImage from "../../common/Input/InputImage";
import AsyncSelect from "react-select/async";
import { searchCitySlice } from "../../../store/slices/citySlice";
import { getCitySlice } from "../../../store/slices/citySlice";

const PhsicianAddUpdateModal = ({
  setModalVisible,
  modalVisible,
  formData,
  handleChange,
  handleAddOrUpdatePhysician,
  Genderoptions,
  cities,
  specializations,
  languages,
  educations,
  statusOptions,
  handleSelectChange,
  treatments,
  handleFileChange,
  imagePreview,
  setInputError,
  submitLoading,
  modalAction,
}) => {
  const dispatch = useDispatch();
  const isPathologySelected = formData.specialization?.some(
    (specialty) => specialty.label.toLowerCase() === "pathology"
  );
  useEffect(() => {
    dispatch(getCitySlice({ status: ["Active"] }));
  }, [dispatch]);

  const loadCityOptions = async (inputValue) => {
    if (!inputValue) return [];
    const result = await dispatch(searchCitySlice({ searchQuery: inputValue }));
    return result?.payload?.map((item) => ({
      value: item._id,
      label: item.name,
    }));
  };

  return (
    <>
      <Modal
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        size={"xl"}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {formData?.id || formData?.userId
              ? "UPDATE PHYSICIAN"
              : "ADD PHYSICIAN"}
          </Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleAddOrUpdatePhysician}>
            <div className="row">
              <div className="col-xl-4">
                <div className="form-group">
                  <InputName
                    name="name"
                    value={formData?.name}
                    onChange={handleChange}
                    placeholder=" Enter Your Name"
                    label="Name"
                    setInputNameError={setInputError}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <InputEmail
                    name="email"
                    value={formData?.email}
                    onChange={handleChange}
                    label="Email"
                    placeholder="Enter Email"
                    setInputEmailError={setInputError}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <InputNumber
                    name="phone"
                    value={formData?.phone}
                    onChange={handleChange}
                    label="Mobile"
                    placeholder="Enter Mobile Number"
                    setInputNumberError={setInputError}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">License</label>
                  <input
                    type="text"
                    className="form-control"
                    name="license"
                    value={formData?.license}
                    onChange={handleChange}
                    placeholder="License Number"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">City</label>
                  <AsyncSelect
                    cacheOptions
                    defaultOptions={cities.map((item) => ({
                      value: item._id,
                      label: item.name,
                    }))}
                    loadOptions={loadCityOptions}
                    onChange={(value) => handleSelectChange(value, "city")} // <-- FIXED
                    placeholder="Select a City"
                    value={
                      formData.city
                        ? { value: formData.city, label: formData.cityName }
                        : null
                    }
                  />
                </div>
              </div>

              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Gender</label>
                  <Select
                    name="gender"
                    value={
                      formData?.gender
                        ? {
                            value: formData?.gender,
                            label: formData?.gender,
                          }
                        : null
                    }
                    placeholder="Select Gender"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "gender")
                    }
                    options={Genderoptions}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">educations</label>
                  <Select
                    isMulti
                    value={formData?.education}
                    placeholder="Please select educations"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "educations")
                    }
                    options={educations?.map((item) => ({
                      value: item?._id,
                      label: item?.educationName,
                    }))}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <InputText
                    name="graduation"
                    value={formData?.graduation}
                    onChange={handleChange}
                    label="Graduation"
                    placeholder="Graduation"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Specialization</label>
                  <Select
                    isMulti
                    value={formData?.specialization}
                    placeholder="Please select specialization"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "specialization")
                    }
                    options={
                      specializations &&
                      specializations?.map((item) => ({
                        value: item?._id,
                        label: item?.specialization,
                      }))
                    }
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Language</label>
                  <Select
                    isMulti
                    name="language"
                    value={formData?.language}
                    placeholder="Please select language"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "language")
                    }
                    options={languages?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Treatments</label>
                  <Select
                    isMulti
                    name="treatments"
                    value={formData?.treatments}
                    placeholder="Please select Treatments"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "treatments")
                    }
                    options={treatments?.map((item) => ({
                      value: item?._id,
                      label: item?.treatmentName,
                    }))}
                    isDisabled={
                      !formData?.specializationId ||
                      formData?.specializationId?.length === 0
                    }
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <InputText
                    name="experience"
                    value={formData?.experience}
                    onChange={handleChange}
                    label="Experience"
                    placeholder="Experience"
                  />
                </div>
              </div>

              <div className="col-xl-4">
                <div className="form-group">
                  <InputText
                    name="twitter"
                    value={formData?.twitter}
                    onChange={handleChange}
                    label="Twitter"
                    placeholder="Twitter"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <InputText
                    name="linkedIn"
                    value={formData?.linkedIn}
                    onChange={handleChange}
                    label="LinkedIn"
                    placeholder="LinkedIn"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <InputText
                    name="facebook"
                    value={formData?.facebook}
                    onChange={handleChange}
                    label="Facebook"
                    placeholder="Facebook"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <InputText
                    name="instagram"
                    value={formData?.instagram}
                    onChange={handleChange}
                    label="Instagram"
                    placeholder="Instagram"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="aboutDoctor" className="col-form-label">
                    About Doctor:
                  </label>
                  <textarea
                    className="form-control"
                    id="aboutDoctor"
                    name="aboutDoctor"
                    placeholder="About Doctor"
                    value={formData?.aboutDoctor}
                    onChange={handleChange}
                    rows={2}
                    onResize={true}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="additionalInfo" className="col-form-label">
                    Additional Information:
                  </label>
                  <textarea
                    className="form-control"
                    id="additionalInfo"
                    name="additionalInfo"
                    placeholder="Additional Information"
                    value={formData?.additionalInfo}
                    onChange={handleChange}
                    rows={2}
                    onResize={true}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <InputImage
                    name="signature"
                    onChange={handleFileChange}
                    placeholder="Signature"
                    label="Signature Upload"
                    setInputImgError={setInputError}
                    multiple={false}
                    required={false}
                    minSize={10 * 1024}
                    maxSize={1 * 1024 * 1024}
                  />
                </div>
                {imagePreview ? (
                  <div className="">
                    <Image
                      src={imagePreview?.file}
                      alt={`${formData?.name} Signature`}
                      className="img-thumbnail"
                    />
                  </div>
                ) : (
                  formData?.file && (
                    <div className="">
                      <Image
                        src={formData?.file}
                        alt={`${formData?.name} Signature`}
                        className="img-thumbnail"
                      />
                    </div>
                  )
                )}
              </div>
              {/* <div className="col-xl-4 mt-5">
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="status" className="col-form-label me-3">
                    Status:
                  </label>
                  {["Active", "Inactive"].map((status) => (
                    <div className="form-check me-3" key={status}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="status"
                        id={status.toLowerCase()}
                        value={status}
                        checked={formData?.status === status}
                        onChange={handleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={status.toLowerCase()}
                      >
                        {status}
                      </label>
                    </div>
                  ))}
                </div>
              </div> */}
              {isPathologySelected && (
                <div className="col-xl-4 mt-5">
                  <div className="form-group d-flex align-items-center">
                    <label
                      htmlFor="verifyPhysician"
                      className="col-form-label me-3"
                    >
                      Do You Need Lab Report Access?
                    </label>
                    {["Yes", "No"].map((option) => (
                      <div className="form-check me-3" key={option}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="verifyPhysician"
                          id={option.toLowerCase()}
                          value={option}
                          checked={formData?.verifyPhysician === option}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={option.toLowerCase()}
                        >
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setModalVisible(false)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={submitLoading}
              >
                {submitLoading ? (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                ) : null}
                {submitLoading
                  ? "Please wait..."
                  : formData?.id || formData?.userId
                    ? "Update"
                    : "Add"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PhsicianAddUpdateModal;
